import React, { Component } from 'react';
import './FetchData.css';
import $ from 'jquery';
import authService from '../../src/components/api-authorization/AuthorizeService';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { Row, Col } from 'react-bootstrap';
import { Alert } from 'reactstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import TagScanModal from './TagScanModal';
import ExamFormInformationModal from './ExamFormInformationModal';
import './ProgressBar.css';
import ProgressBar from "./ProgressBar";
import { Fragment } from 'react';
import infoIcon from "../../src/components/images/icon-infocircle.svg";
import { TimeOutNotification } from "../UserManagement/TimeOutNotification";

const dicomAnonymisation = require("./DicomAnonymisationjs");

export class UploadScans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTagCommentModal: false,
            loading: true,
            scanDto: {
                studyTimepointLookup: {}
            },
            isMsBasePatient: false,
            userName: '',
            isAuthenticated: false,
            fileArray: [],
            anonymizedPatientId: '',
            isMsbirCompliant: false,
            isTAURUS2: false,
            isTAURUS2Compliant: false,
            comment: '',
            isAnonymized: false,
            examForm: null,
            upload: false,
            alertValue: '',
            alertShow: false,
            studies: null,
            isMsbirSite: false,
            isEAFToS: false,
            isEAFToSCompliant: false,
            examFormFileExt: "",
            fileSize: 0,
            showExamFormInformationModal: "none",
            expireMins: 0,
            sesExpNotMins: 0,
            marginTop: "100px",
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.OnChangeComment = this.OnChangeComment.bind(this);
        this.UpdateStudiesTimepoints = this.UpdateStudiesTimepoints.bind(this);
        this.CheckIfEADToSSelected = this.CheckIfEADToSSelected.bind(this);
        this.CheckIfTAURUS2Selected = this.CheckIfTAURUS2Selected.bind(this);
        this.AlertValue = this.AlertValue.bind(this);
        this.AlertShow = this.AlertShow.bind(this);
        this.showInformationModal = this.showInformationModal.bind(this);
        this.hideInformationModal = this.hideInformationModal.bind(this);
        this.startSessionTimeoutCounter = this.startSessionTimeoutCounter.bind(this);
    }
    handleClose() {
        this.setState({
            showTagCommentModal: false,
        }, () =>
            console.log(this.state));
    }
    handleShow() {
        this.setState({
            showTagCommentModal: true,
        }, () =>
            console.log(this.state));
    }
    showInformationModal() {
        this.setState({
            showExamFormInformationModal: "block",
        }, () =>
            console.log(this.state));
    }
    hideInformationModal() {
        this.setState({
            showExamFormInformationModal: "none",
        }, () =>
            console.log(this.state));
    }

    AlertValue(value) {
        this.setState({ alertValue: value });
    }

    AlertShow(value) {
        this.setState({ alertShow: value });
    }
    CheckIfEADToSSelected() {
        const allStudies = this.state.studies;
        var studyName = 'EAFToS';
        var eaftosStudies = [];
        Object.keys(this.state.scanDto.studyTimepointLookup).filter(function (studyId) {
            if (eaftosStudies.length > 0) return;
            eaftosStudies = allStudies.filter(function (e) {
                return (e.id == studyId && e.studyName == studyName);
            });
        });
        this.setState({
            isEAFToS: eaftosStudies.length > 0
        });
        if (eaftosStudies.length > 0)
            return true;
        else
            return false;
    }

    CheckIfTAURUS2Selected() {
        const allStudies = this.state.studies;
        const studyName = "TAURUS2";
        let taurus2Studies = [];
        Object.keys(this.state.scanDto.studyTimepointLookup).filter(function (studyId) {
            if (taurus2Studies.length > 0) return;
            taurus2Studies = allStudies.filter(function (e) {
                return (e.id === studyId && e.studyName === studyName);
            });
        });
        this.setState({
            isTAURUS2: taurus2Studies.length > 0
        });
        if (taurus2Studies.length > 0)
            return true;
        else
            return false;
    }

    UpdateStudiesTimepoints() {
        var Tags = [];
        var validate = true;

        $('#tab_logic tbody tr').each(function () {
            var StudyId = $(this).closest("tr").find(".drpstudies").find(":selected").val();
            var Timepoint = $(this).closest("tr").find(".drptimepoints").val();
            if (Timepoint === "Other") {
                Timepoint = $(this).closest("tr").find(".txtTimepoint").val();
            }
            if (Timepoint !== null)
                Tags.push({
                    Key: StudyId,
                    Value: Timepoint
                });
        })
        if (this.state.scanDto.studyTimepointLookup == null) {
            validate = true;
        }
        // Update Tag Scan
        else {
            var oldTimepointLookup = Object.keys(this.state.scanDto.studyTimepointLookup).map(key => ({
                Key: key,
                Value: this.state.scanDto.studyTimepointLookup[key]
            }));
            if (JSON.stringify(Tags) !== JSON.stringify(oldTimepointLookup))
                validate = true;
        }

        if (validate === true) {
            let Dto = this.state.scanDto;
            let studyTimePoint = {};
            Tags.map(({ Key, Value }) => {
                studyTimePoint[Key] = Value;
            });

            Dto.studyTimepointLookup = studyTimePoint;
            this.setState({
                scanDto: Dto
            });
        }

        const allStudies = this.state.studies;
        this.CheckIfEADToSSelected();
        this.CheckIfTAURUS2Selected();
        const msbirStudies = Object.keys(this.state.scanDto.studyTimepointLookup).filter(function (studyId) {
            return allStudies.filter(function (obj) {
                return obj.id === studyId;
            })[0].isMsBase;
        });
        this.setState({
            isMsBasePatient: msbirStudies.length > 0
        });
    }

    async componentDidMount() {
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keydown', this.handleActivity);
        window.addEventListener('scroll', this.handleActivity);
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
        const accessToken = await authService.getAccessToken();
        const isMsbirSite = await (await fetch('/api/UserRole/msbir/' + user.name,
            {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                })
            }).then(response => response.text()));
        const studies = await (await fetch('/ScanFilter/GetAssignedStudiesDropdown?username=' + user.name,
            {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                })
            }).then(this.startSessionTimeoutCounter())).json();

        const msbirStudies = Object.keys(this.state.scanDto.studyTimepointLookup).filter(function (studyId) {
            return studies[studyId].isMsBase
        });
        this.setState({
            isMsbirSite: isMsbirSite,
            isAuthenticated,
            userName: user && user.name,
            isMsBasePatient: msbirStudies.length > 0,
            studies: studies
        });
    }
    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keydown', this.handleActivity);
        window.removeEventListener('scroll', this.handleActivity);
    }
    startSessionTimeoutCounter() {
        this.setState({
            expireMins: parseInt(window.localStorage.getItem('ExpireMinutes')),
            sesExpNotMins: parseInt(window.localStorage.getItem('SessionExpireNotificationMinutes'))
        });
        window['startNotificationCounter'](this.state.expireMins, this.state.sesExpNotMins);
    }
    handleActivity = () => {
        window['resetCountersOnEvent'](this.state.expireMins, this.state.sesExpNotMins);
    };

    async OnFolderSelect(e) {
        // resets the file array to zero.

        let start = new Date().getTime();
        let refreshFileArray = this.state.fileArray;
        refreshFileArray.length = 0;
        this.setState({ fileArray: refreshFileArray });
        this.setState({ isAnonymized: false });
        this.setState({ upload: false });

        const files = e.target.files;
        const dicomParser = require("dicom-parser");
        for (let i = 0; i < files.length; i++) {
            try {
                const dcmDataset = dicomParser.parseDicom(new Uint8Array(await this.toUint8Buffer(files[i])));
            } catch (error) {
                continue;
            }

            let file = this.state.fileArray;
            file.push(files[i]);
            this.setState({ fileArray: file });
        }
        let end = new Date().getTime();
        this.state.fileArray.length === 0 ? alert("Found 0 valid DICOM files.") : console.log(this.state.fileArray.length);
    }

    OnChangeComment(e) {
        this.setState({ comment: e.target.value });
        let comment = e.target.value;
        let regx = new RegExp('^[A][U]-[0-9]{3}-[0-9]{4}$');
        if ((comment.match(regx) !== null)) {
            this.setState({ isMsBaseIDCompliantComment: true });
        } else {
            this.setState({ isMsBaseIDCompliantComment: false });
        }
    }

    setAnonymizedPatientId(e) {
        this.setState({ anonymizedPatientId: e.target.value });
    }

    MsbirCompatible(input) {
        let anonymousPid = input;
        let regx = new RegExp('^[A-Z]{2}-[0-9]{3}-[0-9]{4}$');
        if (anonymousPid.match(regx) !== null) {
            this.setState({ isMsbirCompliant: true });
        } else {
            this.setState({ isMsbirCompliant: false });
        }
    }

    EAFToSCompatible(input) {
        let anonymousPid = input;
        let regx = new RegExp('^[A][U]-[0-9]{5}$');//restrict to use Australian code
        if (anonymousPid.match(regx) !== null) {
            this.setState({ isEAFToSCompliant: true });
        } else {
            this.setState({ isEAFToSCompliant: false });
        }
    }

    TAURUS2Compatible(input) {
        let anonymousPid = input;
        let regx = new RegExp(/^(Test |)(\d{3}):(\d{2})+$/);
        if (anonymousPid.match(regx) !== null) {
            this.setState({ isTAURUS2Compliant: true });
        } else {
            this.setState({ isTAURUS2Compliant: false });
        }
    }

    Validate() {
        if (this.state.isEAFToS && !this.state.isEAFToSCompliant) {
            return (<><div style={{ color: "red" }}> Patient ID is not EAFToS compliant. <br /> Should be in the form AU-XXXXX<br />where AU & X can only be Australia code and 5-digits respectively. </div></>)
        }
        else if (this.state.isMsBasePatient && !this.state.isMsbirCompliant && !this.state.isEAFToS)
            return (<><div style={{ color: "red" }}> Patient ID is not MSBIR compliant. <br /> Should be in the form YY-XXX-XXXX<br />where X & Y can only be digits and letters respectively. </div></>)
        else if (this.state.isTAURUS2 && !this.state.isTAURUS2Compliant)
            return (<><div style={{ color: "red" }}> Patient ID is not TAURUS2 compliant. <br /> Should be in the form XXX:XX or Test XXX:XX<br />where X & Y can only be digits. </div></>)
    }
    invalidFileSizeErrMsg() {
        if (this.state.fileSize > 5) {
            return (<><div style={{ color: "red" }}> Invalid  file<br />Exam Form file size should not exceed 5 MB. File greater than 5 MB won't be uploaded.'<br /></div></>)
        }
    }

    ValidateCommentForMSBaseID() {
        if (this.state.isMsBasePatient && !this.state.isMsBaseIDCompliantComment && this.state.examForm != null) {
            return (<><div style={{ color: "red" }}> Comment is not MSBaseID compliant. <br /> Should be in the form AU-XXX-XXXX<br />where AU & X can only be Australia code and digits respectively. </div></>)
        }
    }

    onExamFormSelected(e) {
        const fileSize = e.target.files[0].size;
        const fileSizeInMB = this.convertBytes(fileSize);
        let examFormFileExt = e.target.files[0].name.split('.').pop();
        this.checkForValidExamForm(fileSizeInMB, examFormFileExt, e);
    }
    checkForValidExamForm(fileSizeInMB, examFormFileExt, e) {
        if (fileSizeInMB > 5 || fileSizeInMB == 0) {
            this.setState({
                examForm: null,
                fileSize: fileSizeInMB
            });
        }
        else {
            this.setState({
                examForm: e.target.files[0],
                examFormFileExt: examFormFileExt,
                fileSize: fileSizeInMB
            });
        }
    }
    convertBytes(bytes) {
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
        if (bytes == 0) {
            return 0
        }

        const i = 2;

        if (i == 0) {
            return bytes
        }

        return (bytes / Math.pow(1024, i)).toFixed(1)
    }
    toUint8Buffer(file) {
        return new Promise((resolve) => {
            let reader = new FileReader();
            reader.onload = () => { resolve(reader.result) };
            reader.readAsArrayBuffer(file);
        });
    }

    async StartAnonymization() {
        let start = new Date().getTime();
        let anonymousPid = this.state.anonymizedPatientId;
        let files = this.state.fileArray;
        for (let i = 0; i < files.length; i++) {
            let dcmFile = await this.toUint8Buffer(files[i]);
            files[i] = await dicomAnonymisation.anonymize(new Uint8Array(dcmFile), anonymousPid);
        }
        this.setState({ fileArray: files });
        this.setState({ isAnonymized: true });
        let end = new Date().getTime();
        console.log("Anonymization took: %i", end - start);
    }

    async StartUpload() {
        let randomId = Math.floor((Math.random() * 100000)).toString();
        let stamp = new Date();
        let sessionId = stamp.getFullYear().toString() + (stamp.getMonth() + 1).toString() + stamp.getDate().toString() +
            stamp.getHours().toString() + stamp.getMinutes().toString() + stamp.getSeconds().toString() + randomId;
        let lastIndex = 0;
        let dcmFiles = this.state.fileArray;

        console.log(this.state.upload);
        const progressBarFill = document.querySelector("#progressBar > .progress-bar-fill");
        const progressBarText = progressBarFill.querySelector(".progress-bar-text");
        progressBarFill.style.width = "0%";

        let url = "/api/UploadFile";
        let fd = new FormData();
        while (lastIndex < dcmFiles.length) {
            fd.append("UploadSessionId", sessionId);

            if (dcmFiles[lastIndex] !== undefined) {
                fd.append("Files", dcmFiles[lastIndex].get("dcmfile"));
            }

            if (lastIndex === dcmFiles.length - 1) {
                fd.append("IsLastFile", true);
                fd.append("IsMsbir", this.state.isMsBasePatient && this.state.isMsbirSite);
                fd.append("Comment", this.state.comment);
                let examFormBlob = null;
                if (this.state.examForm !== null) {
                    examFormBlob = this.state.examForm;
                }
                fd.append("ExamForm", examFormBlob);
                fd.append("StudyTimepointsJson", JSON.stringify(this.state.scanDto.studyTimepointLookup));
                fd.append("Username", this.state.userName);
                fd.append("PatientId", this.state.anonymizedPatientId);
            }
            lastIndex++;
        }

        $.ajax({
            async: true,
            crossDomain: true,
            url: url,
            timeout: 0,
            headers: { "Authorization": 'Bearer ' + await authService.getAccessToken() },
            type: "POST",
            processData: false,
            contentType: false,
            data: fd,
            xhr: function () {
                var xhr = new window.XMLHttpRequest();

                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        if (evt.loaded === evt.total) {
                            const progressText = "Finalizing...";
                            progressBarText.textContent = progressText;
                        } else {
                            const percentComplete = evt.loaded / evt.total * 100;
                            progressBarFill.style.width = percentComplete.toFixed(2) + "%";
                            progressBarText.textContent = percentComplete.toFixed(2) + "%";
                        }
                    }
                }, false);

                return xhr;
            },
            success: (result) => {
                console.log(result["message"]);
                progressBarText.textContent = "100% : Upload Successful!";
                this.AlertShow(true);
                this.AlertValue('success');
                this.setState({ upload: true });
            },
            error: (xhr, status, error) => {
                var errorMessage = xhr.status + ': ' + xhr.statusText;
                console.log(errorMessage);
                progressBarFill.style.background = "red";
                progressBarText.textContent += " Upload Failed. Try Again!";
                this.AlertShow(true);
                this.AlertValue('danger');
                this.setState({ upload: false });
            }
        });
    }

    async HandleUpload(e) {
        this.setState({ upload: true });
        if (!this.state.isAnonymized)
            await this.StartAnonymization();
        await this.StartUpload();
    }

    displayAlert() {
        if (this.state.alertShow && this.state.alertValue === 'success') {
            return (
                <Fragment>
                    <Alert fade={false} color={this.state.alertValue} isOpen={this.state.AlertShow} toggle={(e) => this.AlertShow(false)}>
                        File(s) uploaded successfully.
                    </Alert>
                </Fragment>

            )
        }
        if (this.state.alertShow && this.state.alertValue === 'danger') {
            return (
                <Fragment>
                    <Alert fade={false} color={this.state.alertValue} isOpen={this.state.AlertShow} toggle={(e) => this.AlertShow(false)}>
                        File(s) upload failed ! Please try again.
                    </Alert>
                </Fragment>

            )
        }
    }

    render() {
        return (
            <>
                <div>
                    {this.displayAlert()}
                </div>
                <Form>

                    <Container>

                        <Row>
                            <Col md={2}><Form.Label>DICOM Directory</Form.Label></Col>
                            <Col md={4}><Form.Control className="mb-3" directory="" webkitdirectory="" type="file" accept="application/dicom" onChange={(e) => this.OnFolderSelect(e)} />
                                {this.state.fileArray.length} DICOM file(s) detected.
                            </Col>

                        </Row>

                        <Row>

                            <Col md={2}><Form.Label>Anonymised Patient ID</Form.Label></Col>
                            <Col md={4}><Form.Control type="text" id="anonymisedpId" style={{ height: "38px" }} onChange={(e) => {
                                this.setAnonymizedPatientId(e);
                                this.MsbirCompatible(e.target.value);
                                this.EAFToSCompatible(e.target.value);
                                this.TAURUS2Compatible(e.target.value);
                            }}
                            /></Col>
                            <Col md={4}>{this.Validate()} </Col>

                        </Row>

                        <Row>

                            <Col md={2}><Form.Label>Studies/Timepoints </Form.Label></Col>
                            <Col md={4}>
                                <Button variant="primary" onClick={(e) => this.handleShow()} > Tag Scan</Button>{' '}

                            </Col>
                        </Row>

                        <Row>

                            <Col md={2}><Form.Label>Comment</Form.Label></Col>
                            <Col md={4}><Form.Control as="textarea" onChange={(e) => this.OnChangeComment(e)} onKeyOut={(e) => this.handleKeyDown(e)} /></Col>
                            <Col md={4}>{this.ValidateCommentForMSBaseID()} </Col>
                        </Row>
                        <Row>

                            <Col md={2}><Form.Label>Exam Form</Form.Label></Col>
                            <Col md={4}><Form.Control type="file" accept="application/pdf,.jpg,.jpeg,.png,.gif,.svg" onChange={(e) => this.onExamFormSelected(e)} /></Col>
                            <Col md={4}>
                                <div>
                                    <img src={infoIcon} style={{ marginLeft: "-300px" }} onClick={(e) => { this.showInformationModal() }} title="View details" alt="" />
                                </div>
                            </Col>
                            <Col md={4}>{this.invalidFileSizeErrMsg()} </Col>

                        </Row>
                        <Row>
                            <Col md={3}><Button variant="secondary">Cancel</Button></Col>
                            <Col md={3}><Button variant="primary" disabled={!this.state.isEAFToSCompliant && this.state.isEAFToS || !this.state.isTAURUS2Compliant && this.state.isTAURUS2 || !this.state.isMsbirCompliant && this.state.isMsBasePatient || this.state.upload || Object.keys(this.state.scanDto.studyTimepointLookup).length == 0} onClick={(e) => this.HandleUpload(e)}>Upload</Button>
                                <div >{ProgressBar(this.state.isAnonymized, this.state.upload)}</div>
                            </Col>

                        </Row>
                        <TagScanModal
                            stateProps={this.state}
                            handleClose={this.handleClose}
                            handleShow={this.handleShow}
                            UpdateStudiesTimepoints={this.UpdateStudiesTimepoints}
                        />

                        <ExamFormInformationModal
                            stateProps={this.state}
                            hideInformationModal={this.hideInformationModal}
                            showInformationModal={this.showInformationModal}

                        />
                        <TimeOutNotification
                            sessionState={this.state}

                        />
                    </Container>

                </Form>
            </>

        );
    }
}